<template>
  <div class="container">
    <Table :columns="columns" :data="expense_invoice_registers"></Table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      columns: [
        {
          title: '序号',
          align: 'center',
          render: (h, params) => {
            return h('div', `发票${params.index + 1}`)
          }
        },
        {
          title: '发票号码',
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.uid)
          }
        },
        {
          title: '发票金额',
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.price)
          }
        }
      ]
    }
  },
  props: {
    expense_invoice_registers: {
      type: Array,
      default: () => []
    }
  },
  created() {},
}
</script>